import { useEffect, useState } from "react";
import { Phone } from "lucide-react";
import LogoMark from "@/components/LogoMark";
import { PHONE_DISPLAY, PHONE_TEL } from "@/lib/site";

const NAV = [
  { label: "Servizi", href: "#servizi" },
  { label: "Emergenza", href: "#emergenza" },
  { label: "Copertura", href: "#copertura" },
  { label: "Contatti", href: "#contatti" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
        scrolled ? "glass border-b border-line py-2.5" : "py-4"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 sm:px-6">
        <a
          href="#top"
          data-testid="header-logo"
          className="group flex items-center gap-3"
          aria-label="RomaTech24 — torna in cima"
        >
          <span className="transition-transform duration-500 group-hover:rotate-[-6deg]">
            <LogoMark size={40} />
          </span>
          <span className="leading-none">
            <span className="block font-display text-lg font-extrabold tracking-tight text-white">
              Roma<span className="text-volt">Tech24</span>
            </span>
            <span className="mt-1 hidden font-mono text-[10px] uppercase tracking-[0.22em] text-slate-400 sm:block">
              Pronto intervento · Roma
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-7 lg:flex" aria-label="Navigazione principale">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="relative text-sm font-medium text-slate-300 transition-colors hover:text-white after:absolute after:-bottom-1.5 after:left-0 after:h-px after:w-0 after:bg-volt after:transition-all after:duration-300 hover:after:w-full"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2.5">
          <span className="mr-1 hidden items-center gap-2 rounded-full border border-line bg-ink/60 px-3 py-1.5 xl:flex">
            <span className="h-2 w-2 animate-pulse-dot rounded-full bg-emerald-400" />
            <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-slate-300">
              Tecnici in zona · ora
            </span>
          </span>

          <a
            href={PHONE_TEL}
            data-testid="header-phone-button"
            className="group flex h-11 items-center gap-2.5 rounded-full bg-volt px-4 font-display text-sm font-bold text-night shadow-[0_0_24px_rgba(255,195,0,0.35)] transition-all duration-300 hover:bg-volthi hover:shadow-[0_0_36px_rgba(255,195,0,0.55)] sm:px-5"
          >
            <Phone size={17} strokeWidth={2.4} className="transition-transform duration-300 group-hover:rotate-12" />
            <span className="hidden sm:inline">{PHONE_DISPLAY}</span>
            <span className="sm:hidden">Chiama</span>
          </a>
        </div>
      </div>
    </header>
  );
}
